import { Store } from './createStore';
import State from './state';

type Unsubscribe = () => void;

const observeStore = (store: Store, onChange: (state: State) => void): Unsubscribe => {
  let currentState: State;

  const handleChange = () => {
    const nextState = store.getState();

    if (nextState !== currentState) {
      currentState = nextState;

      onChange(nextState);
    }
  };

  return store.subscribe(handleChange);
};

export default observeStore;
